export default import.meta.ROLLDOWN_FILE_URL_NB6A4PeJDEESnqQnqz0_Dw